// extracted by mini-css-extract-plugin
export var card = "_bc-1";
export var container = "_bc-0";